import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { historyUtils } from '@wartek-id/toolbox-helper'

const PageHeader = () => {
  const router = useRouter()

  return (
    <HeaderBar fixed className="shadow-sm">
      <HeaderBarLeftAction
        onClick={() => historyUtils?.backToApp?.(router?.back)}
      />
      <HeaderBarTitle>Ide Praktik</HeaderBarTitle>
    </HeaderBar>
  )
}

export default PageHeader
